<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener('DOMContentLoaded', function() {
	  const container = document.querySelector('.product-description-container');
	  const content = document.querySelector('.description-content');
	  
	  
	  if (content.scrollHeight > 50) {
	    
	    const toggle = document.createElement('div');
	    toggle.className = 'read-more-toggle';
	    toggle.style.cssText = 'color: #3e6187; cursor: pointer; text-align: left; padding: 5px 0; font-weight: bold;';
	    toggle.textContent = 'Read More';
	    toggle.onclick = function() {
	      if (content.style.maxHeight === '50px') {
	        content.style.maxHeight = content.scrollHeight + 'px';
	        toggle.textContent = 'Read Less';
	      } else {
	        content.style.maxHeight = '50px';
	        toggle.textContent = 'Read More';
	      }
	    };
	    container.appendChild(toggle);
	  } else {
	    
	    content.style.maxHeight = 'none';
	  }
	});